<template>
	<div class="feedPage">
		<userHeader bag="#fff" />
		<fuHeader />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="feedBox">
				<div class="feedLeft">
					<div class="feedItem" @click="currCompBtn('xuqiuSqA', 0)" :class="{ active: flag == 0 }">
						<img src="@/assets/img/fk2.svg" v-show="flag == 1" alt="" />
						<img src="@/assets/img/fk.svg" v-show="flag == 0" alt="" />
						<span>申请资源</span>
					</div>
					<div class="feedItem" @click="currCompBtn('xuqiuSqB', 1)" :class="{ active: flag == 1 }">
						<img src="@/assets/img/fkjlu.svg" v-show="flag == 0" alt="" />
						<img src="@/assets/img/fkjl.svg" v-show="flag == 1" alt="" />
						<span>申请记录</span>
					</div>
				</div>
				<div class="feedRight">
					<component :is="currentComponent" @hdFn="hdFn" :decData="decData" @currCompBtn="currCompBtn"></component>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import xuqiuSqA from '@/page/tab/xuqiuSqA';
import xuqiuSqB from '@/page/tab/xuqiuSqB';
import xuqiuSqC from '@/page/tab/xuqiuSqC';
import userHeader from '@/components/hearder/userHeader';
import fuHeader from '@/components/hearder/fuHeader';

export default {
	name: 'xuqiuSq',
	data() {
		return {
			flag: 0,
			decData: '',
			currentComponent: 'xuqiuSqA'
		};
	},
	components: {
		userHeader,
		xuqiuSqA,
		xuqiuSqB,
		xuqiuSqC,
		fuHeader
	},
	methods: {
		currCompBtn(cont, type) {
			this.flag = type;
			this.currentComponent = cont;
		},
		hdFn(type, item) {
			this.decData = item ? item : '';
			this.currentComponent = type;
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.feedPage {
	background: #f5f5f5;
	.feedBox {
		min-height: calc(100vh - 123px);
		width: 1200px;
		margin: 10px auto 0;
		box-sizing: border-box;
		display: flex;
		.feedLeft {
			width: 140px;
			margin-right: 10px;
			background: #fff;
			padding: 35px 20px 35px 14px;
			box-sizing: border-box;
			height: 164px;
			.feedItem {
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 36px;
				cursor: pointer;
				font-size: 16px;
				font-weight: bold;
				&:last-of-type {
					margin-bottom: 0;
				}
				img {
					width: 30px;
					height: 30px;
					margin-right: 8px;
				}
				span {
					color: #333333;
					font-size: 16px;
				}
			}
			.active {
				span {
					color: #1d7b3a;
				}
			}
		}
		.feedRight {
			flex: 1;
			background: #fff;
		}
	}
}
</style>
